import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class BackgroundGradient extends BaseOption {
  static userInterfaceComponent = {
    label: "Background Gradient",
    component: inspectorTools.GRADIENT_PICKER,
    canSetOtherStates: [BaseOption.$states.HOVER],
  };

  static defaultValue = "none";
}
